import type { ReactNode } from 'react';

type LotteryFaqSectionProps = {
  children: ReactNode;
};

/**
 * Play-page frame for the FAQ. Matches the checkout layout column it used to sit in:
 * page inset, the 640px main column from xl, and the space below it before the footer.
 */
function LotteryFaqSection({ children }: LotteryFaqSectionProps) {
  return (
    <div className="ll-grid-container pb-16" data-testid="lottery-faq-section">
      <div className="ll-container-inner grid grid-cols-1 gap-y-8 xl:grid-cols-[minmax(0,640px)_1fr] xl:gap-x-28">
        <div className="flex flex-col gap-y-10 xl:row-1">{children}</div>
      </div>
    </div>
  );
}

export { LotteryFaqSection };
export type { LotteryFaqSectionProps };
